var map = {
	"./alert_partner_gold_x2_new.png": 786,
	"./alert_partner_platinum_x2_new.png": 787,
	"./alert_partner_silver_x2_new.png": 788,
	"./alert_partner_white_x2_new.png": 789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 785;